import React from 'react'
import { connect } from 'react-redux'
import { withStyles, Grid } from '@material-ui/core'
import styles from 'components/AddOrEditTaskPage/styles'
import Select from 'components/AddOrEditTaskPage/Select'
import TemplateName from 'components/TemplateForm/TemplateName'
import Subject from 'components/TemplateForm/Subject'
import SMS from 'components/AddOrEditTaskPage/FormContent/SMS'
import language from 'utils/vast-languagepack'
// import CodeEditor from 'components/TemplateForm/CodeEditor'

export default connect((state) => ({
  value: state.tasks.addOrEdit.fields.selectedActionPrediction.value,
  codeEditorDisplayed: state.email.codeEditorDisplayed,
  automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
}))(
  withStyles(styles)(
    ({ value, classes, codeEditorDisplayed, automationTypeSelected }) => (
      <Grid
        container
        style={{ backgroundColor: '#fff', borderRadius: 35, padding: 14 }}
      >
        {value === 'email' ? (
          <Grid item xs={12}>
            <Grid container spacing={16}>
              <Grid item xs={12}>
                {automationTypeSelected !== 'stage' ? <Select /> : null}
              </Grid>
              <Grid item xs={12}>
                <TemplateName
                  helperText={language.task.add.helperText.templateName}
                />
              </Grid>
              <Grid item xs={12}>
                <Subject helperText={language.task.add.helperText.subject} />
              </Grid>
            </Grid>
          </Grid>
        ) : null}
        {value === 'sms' ? (
          <SMS automationTypeSelected={automationTypeSelected} />
        ) : null}
      </Grid>
    ),
  ),
)
